/* src/app/modules/print-cards/components/cards/backgrounds/custom-cards-5x5/pops-cannabis-5-by5-card-background/pops-cannabis-5-by-5-card-background.component.scss */
:host {
  width: 100%;
  height: 100%;
}
/*# sourceMappingURL=pops-cannabis-5-by-5-card-background.component.css.map */
